import { render, staticRenderFns } from "./HeaderNotificationBody.vue?vue&type=template&id=5dce0586&"
import script from "./HeaderNotificationBody.vue?vue&type=script&lang=js&"
export * from "./HeaderNotificationBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports